import Vue from 'vue'
import Vuex from 'vuex'
import {
    Message
} from 'element-ui';
import router from '../router/index';
import axios from 'axios'
import list from '../store/list'
import answerPastReal from '../store/answerPastReal'
Vue.use(Vuex)

export default new Vuex.Store({
    modules:{
        list,
        answerPastReal
    }
})